const mutations = {
  getBanner: (state, banner_id) => {
    state.banner_id = banner_id;
  },
  postBanner: (state, new_banner) => {
    state.banner.push(new_banner);
  },
};

export default mutations;
